import * as Sentry from "@sentry/vue";

import "bootstrap";

import "../styles/styles.scss";

import Vue from "vue";
import store from "./store/index";
import App from "./components/app.vue";

if (window.SENTRY_CONFIG && window.SENTRY_CONFIG.dsn) {
    Sentry.init({
        Vue,
        dsn: window.SENTRY_CONFIG.dsn,
        release: window.SENTRY_CONFIG.release,
        environment: window.SENTRY_CONFIG.environment,
        sendDefaultPii: true,
    });

    if (window.SENTRY_CONFIG.user) {
        Sentry.setUser({
            id: window.SENTRY_CONFIG.user.id,
            email: window.SENTRY_CONFIG.user.email,
            username: window.SENTRY_CONFIG.user.username,
        });
    }
}

window.addEventListener("load", function () {
    if (document.getElementById("vue-app")) {
        new Vue({
            el: "#vue-app",
            store: store,
            components: {
                app: App,
            },
        });
    }
});
